import React from 'react';
import { Input, Label, Select, SelectOption } from '@americanexpress/dls-react';
import { validateInputs, validateField } from '../../validators/vendorIntakeFormValidator';
import * as LABELCONST from '../../constants/constFileLabelsVendor';
import MousePopover from '../Util/UIComp/MouseHover';
import AttachFiles from '../Util/AttachFiles';
import { isCountryJapan, isCountrySweden, isCountryPhilippenes } from '../../helper/functions';


// TODO: Add constant for AttachFiles verbiage
const SupplierBankingInfo = (props) => (
  <div className="margin-responsive fade-in">
    <div>
      <h1 className="header-text">{LABELCONST.SUPPLIER_BANKING_INFORMATION}</h1>
      <div className="new-line" />
      <span>
        Bank details are mandatory where payment method is bank transfer/auto
        pay.
      </span>
      <div className="new-line" />
    </div>
    <div className='width-75'>
      <Label className="pad-responsive-t">
        {LABELCONST.BANK_NAME}
      </Label>
      <Input
        id="bankName"
        maxLength={100}
        value={props.formData.bankName}
        onChange={(event) => {
          props.setFormData({ ...props.formData, bankName: event.target.value });
          props.setFormErrors({
            ...props.formErrors,
            bankName: validateField(
              event.target.value,
              'dashAlphanumeric',
              `Bank Name`
            ),
          });
        }}
        onKeyUp={() => validateInputs(
          props.page,
          props.setFormErrors,
          props.formData,
          props.isNextClicked
        )}
      />
      <p className="dls-red">{props.formErrors.bankName}</p>

      <div className='pull-down-4'>
        <Label className="pad-responsive-t">
          {LABELCONST.BIC}
        </Label>
        <MousePopover
          headingVal={LABELCONST.BIC}
          textValue={"In case BIC code is not available then please enter XXXXXXXX (8 times X's)."}
        />
      </div>
      <Input
        id="bic"
        maxLength={50}
        value={props.formData.bic}
        onChange={(event) => {
          props.setFormData({ ...props.formData, bic: event.target.value });
          props.setFormErrors({
            ...props.formErrors,
            bic: validateField(
              event.target.value,
              'dashAlphanumeric',
              `BIC/Swift Code`
            ),
          });
        }}
        onKeyUp={() => validateInputs(
          props.page,
          props.setFormErrors,
          props.formData,
          props.isNextClicked
        )}
      />
      <p className="dls-red">{props.formErrors.bic}</p>

      <Label className="pad-responsive-t">
        {LABELCONST.BRANCH_NAME}
      </Label>
      <Input
        id="branchName"
        maxLength={100}
        value={props.formData.branchName}
        onChange={(event) => {
          props.setFormData({
            ...props.formData,
            branchName: event.target.value,
          });
          props.setFormErrors({
            ...props.formErrors,
            branchName: validateField(
              event.target.value,
              'dashAlphanumeric',
              `Branch Name`
            ),
          });
        }}
        onKeyUp={() => validateInputs(
          props.page,
          props.setFormErrors,
          props.formData,
          props.isNextClicked
        )}
      />
      <p className="dls-red">{props.formErrors.branchName}</p>

      <Label className="pad-responsive-t">
        {isCountryPhilippenes(props.formData?.billingCountry?.CountryName) ? 'Personate ID / BRSTN' : LABELCONST.BRANCH_CODE}
      </Label>
      <Input
        id="branchCode"
        maxLength={50}
        value={props.formData.branchCode}
        onChange={(event) => {
          props.setFormData({
            ...props.formData,
            branchCode: event.target.value,
          });
          props.setFormErrors({
            ...props.formErrors,
            branchCode: validateField(
              event.target.value,
              'dashAlphanumeric',
              `Branch Code`
            ),
          });
        }}
        onKeyUp={() => validateInputs(
          props.page,
          props.setFormErrors,
          props.formData,
          props.isNextClicked
        )}
      />
      <p className="dls-red">{props.formErrors.branchCode}</p>
      <div className="pull-down-4">
        <Label className="pad-responsive-t">
          {LABELCONST.ACCOUNT_NUMBER}
        </Label>
        <MousePopover
          headingVal={LABELCONST.ACCOUNT_NUMBER}
          textValue={LABELCONST.BANK_ACCOUNT_NUMBER_TEXT_INFO}
        />
      </div>
      <Input
        id="accountNumber"
        maxLength={100}
        value={props.formData.accountNumber}
        onChange={(event) => {
          props.setFormData({
            ...props.formData,
            accountNumber: event.target.value,
          });
        }}
        onKeyUp={() => validateInputs(
          props.page,
          props.setFormErrors,
          props.formData,
          props.isNextClicked
        )}
      />
      <span>{LABELCONST.ACCOUNT_NUMBER_VERBIAGE_INFO}</span>
      <p className="dls-red">{props.formErrors.accountNumber}</p>
      <div className='pull-down-4'>
        <Label className="pad-responsive-t">
          {LABELCONST.BANK_CODE}
        </Label>
        <MousePopover
          headingVal={LABELCONST.BANK_CODE}
          textValue={"Provide the 32 alphanumeric IBAN code comprising of the country code, two check digits and a long and detailed bank account-number used in bank wire transfers."}
        />
      </div>
      <Input
        id="bankCode"
        maxLength={32}
        value={props.formData.bankCode}
        onChange={(event) => {
          props.setFormData({ ...props.formData, bankCode: event.target.value });
          props.setFormErrors({
            ...props.formErrors,
            bankCode: validateField(
              event.target.value,
              'dashAlphanumeric',
              `Bank Code`
            ),
          });
        }}
        onKeyUp={() => validateInputs(
          props.page,
          props.setFormErrors,
          props.formData,
          props.isNextClicked
        )}
      />
      <p className="dls-red">{props.formErrors.bankCode}</p>

      <Label className="pad-responsive-t">
        {LABELCONST.ACCOUNT_TYPE}
      </Label>
      <Select
        id="accountType"
        className='min-width-100'
        value={props.formData.accountType}
        onChange={(event) => {
          props.setFormData({ ...props.formData, accountType: event.target.value });
        }}
        onMouseOut={() =>
          validateInputs(
            props.page,
            props.setFormErrors,
            props.formData,
            props.isNextClicked
          )
        }
      >
        <SelectOption value="" />
        {props.staticData.accountTypes?.map((field) => (
          <SelectOption
            key={field}
            value={field}
          >
            {field}
          </SelectOption>
        ))}
      </Select>
      <div className='pull-down-4'>
        <Label className="pad-responsive-t">{LABELCONST.ABA}</Label>
        <MousePopover
          headingVal={LABELCONST.ABA}
          textValue={"BSB number should be captured in the following format : < Bank Code > < hyphen > < Branch Code > .E.g., 123-456 (Australia), 12-3456 (New Zealand)"}
        />
      </div>
      <Input
        id="aba"
        maxLength={100}
        value={props.formData.aba}
        onChange={(event) => {
          props.setFormData({ ...props.formData, aba: event.target.value });
          props.setFormErrors({
            ...props.formErrors,
            aba: validateField(
              event.target.value,
              'dashAlphanumeric',
              `ABA`
            ),
          });
        }}
        onKeyUp={() => validateInputs(
          props.page,
          props.setFormErrors,
          props.formData,
          props.isNextClicked
        )}
      />
      <p className="dls-red">{props.formErrors.aba}</p>

      <Label className="pad-responsive-t">
        {LABELCONST.INTERMEDIATE_BANK_NAME}
      </Label>
      <Input
        id="intermediateBankName"
        maxLength={100}
        value={props.formData.intermediateBankName}
        onChange={(event) => {
          props.setFormData({
            ...props.formData,
            intermediateBankName: event.target.value,
          });
          props.setFormErrors({
            ...props.formErrors,
            intermediateBankName: validateField(
              event.target.value,
              'dashAlphanumeric',
              `Intermediate Bank Name`
            ),
          });
        }}
        onKeyUp={() => validateInputs(
          props.page,
          props.setFormErrors,
          props.formData,
          props.isNextClicked
        )}
      />
      <p className="dls-red">{props.formErrors.intermediateBankName}</p>
      <Label className="pad-responsive-t">
        {LABELCONST.INTERMEDIATE_BANK_BIC}
      </Label>
      <Input
        id="intermediateBankBic"
        maxLength={50}
        value={props.formData.intermediateBankBic}
        onChange={(event) => {
          props.setFormData({
            ...props.formData,
            intermediateBankBic: event.target.value,
          });
          props.setFormErrors({
            ...props.formErrors,
            intermediateBankBic: validateField(
              event.target.value,
              'dashAlphanumeric',
              `Intermediate Bank BIC`
            ),
          });
        }}
        onKeyUp={() => validateInputs(
          props.page,
          props.setFormErrors,
          props.formData,
          props.isNextClicked
        )}
      />
      <p className="dls-red">{props.formErrors.intermediateBankBic}</p>
      <Label className="pad-responsive-t">
        {LABELCONST.INTERMEDIATE_BANK_BRANCH_NAME}
      </Label>
      <Input
        id="intermediateBankBranchName"
        maxLength={100}
        value={props.formData.intermediateBankBranchName}
        onChange={(event) => {
          props.setFormData({
            ...props.formData,
            intermediateBankBranchName: event.target.value,
          });
          props.setFormErrors({
            ...props.formErrors,
            intermediateBankBranchName: validateField(
              event.target.value,
              'dashAlphanumeric',
              `Intermediate Bank Branch Name`
            ),
          });
        }}
        onKeyUp={() => validateInputs(
          props.page,
          props.setFormErrors,
          props.formData,
          props.isNextClicked
        )}
      />
      <p className="dls-red">{props.formErrors.intermediateBankBranchName}</p>
      <Label className="pad-responsive-t">
        {LABELCONST.INTERMEDIATE_BANK_BRANCH_CODE}
      </Label>
      <Input
        id="intermediateBankBranchCode"
        maxLength={50}
        value={props.formData.intermediateBankBranchCode}
        onChange={(event) => {
          props.setFormData({
            ...props.formData,
            intermediateBankBranchCode: event.target.value,
          });
          props.setFormErrors({
            ...props.formErrors,
            intermediateBankBranchCode: validateField(
              event.target.value,
              'dashAlphanumeric',
              `Intermediate Bank Branch Code`
            ),
          });
        }}
        onKeyUp={() => validateInputs(
          props.page,
          props.setFormErrors,
          props.formData,
          props.isNextClicked
        )}
      />
      <p className="dls-red">{props.formErrors.intermediateBankBranchCode}</p>
      <Label className="pad-responsive-t">
        {LABELCONST.INTERMEDIATE_BANK_ACCOUNT_NUMBER}
      </Label>
      <Input
        id="intermediateBankAccountNumber"
        maxLength={100}
        value={props.formData.intermediateBankAccountNumber}
        onChange={(event) => props.setFormData({
          ...props.formData,
          intermediateBankAccountNumber: event.target.value,
        })}
      />

      <Label className="pad-responsive-t">
        {LABELCONST.INTERMEDIATE_BANK_ABA}
      </Label>
      <Input
        id="intermediateABA"
        maxLength={100}
        value={props.formData.intermediateABA}
        onChange={(event) => props.setFormData({
          ...props.formData,
          intermediateABA: event.target.value,
        })}
      />
      {isCountryJapan(props.formData.billingCountry.CountryName) && (
        <div>
          <Label className="pad-responsive-t">
            {LABELCONST.SUPPLIER_JAPAN_BANK_NAME}
          </Label>
          <Input
            id="japanBankName"
            maxLength={100}
            value={props.formData.japanBankName}
            onChange={(event) => props.setFormData({
              ...props.formData,
              japanBankName: event.target.value,
            })}
            onKeyUp={() => validateInputs(
              props.page,
              props.setFormErrors,
              props.formData,
              props.isNextClicked
            )}
          />
          <p className="dls-red">{props.formErrors.japanBankName}</p>
        </div>
      )}
      {isCountryJapan(props.formData.billingCountry.CountryName) && (
        <div>
          <Label className="pad-responsive-t">
            {LABELCONST.SUPPLIER_JAPAN_BRANCH_NAME}
          </Label>
          <Input
            id="japanBranchName"
            maxLength={100}
            value={props.formData.japanBranchName}
            onChange={(event) => props.setFormData({
              ...props.formData,
              japanBranchName: event.target.value,
            })}
            onKeyUp={() => validateInputs(
              props.page,
              props.setFormErrors,
              props.formData,
              props.isNextClicked
            )}
          />
          <p className="dls-red">{props.formErrors.japanBranchName}</p>
        </div>
      )}
      
      {isCountrySweden(props.formData?.billingCountry?.CountryName ?? '') && (
        <div>
          <Label className="pad-responsive-t">
            {LABELCONST.BANK_GIRO_NUMBER}
          </Label>
          <Input
            id="bankGiroNumber"
            maxLength={100}
            value={props.formData.bankGiroNumber}
            onChange={(event) => props.setFormData({
              ...props.formData,
              bankGiroNumber: event.target.value,
            })}
            onKeyUp={() => validateInputs(
              props.page,
              props.setFormErrors,
              props.formData,
              props.isNextClicked
            )}
          />
          <p className="dls-red">{props.formErrors.bankGiroNumber}</p>
        </div>
      )}


      <Label className="pad-responsive-t">
        Attach corresponding documents here
      </Label>
      <div className="new-line" />
      <span>
        Tax Id and Bank details document are requested, to setup the vendor in AMEX database. Upload your corresponding documents you're sending to your American Express Contact. Please note, each file cannot exceed 3MBs.
      </span>
      <div className="new-line" />
      <AttachFiles
        id="supplierDocuments"
        isDisabled={false}
        isMultiple={true}
        files={props.files}
        setFiles={props.setFiles}
        alreadyAttachedFiles={props.alreadyAttachedFiles}
        setAlreadyAttachedFiles={props.setAlreadyAttachedFiles}
        uploadedDocs={props.uploadedDocs}
        setUploadedDocs={props.setUploadedDocs}
        deletedDocGuids={props.deletedDocGuids}
        setDeletedDocGuids={props.setDeletedDocGuids}
      />
    </div>
  </div>
);

export default SupplierBankingInfo;
